module.exports = __webpack_public_path__ + "8ed4a1f8909a9b1902c034dc775c8dd7.webp";